import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { SocketProvider } from "./context/SocketProvider";
import { ImageSelectionProvider } from "./context/useImageSelection";
import { SettingsProvider } from "./context/SettingsContext";

// AntiScroll code
document.addEventListener('touchmove', (e) => {
  e.preventDefault();
}, { passive: false });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SocketProvider>
        <ImageSelectionProvider>
          <SettingsProvider>
            <App />
          </SettingsProvider>
        </ImageSelectionProvider>
      </SocketProvider>
    </BrowserRouter>
  </React.StrictMode>
);
